import React from "react";
import Header from "../components/landing/Header";
import HeroSection from "../components/landing/HeroSection";
import ContentWorkflow from "../components/landing/ContentWorkflow";
import AutomatedContentPipeline from "../components/landing/AutomatedContentPipeline";
import ProblemsAndSolutions from "../components/landing/ProblemsAndSolutions";
import SEOAnalysisSection from "../components/landing/SEOAnalysisSection";
import WriteArticles from "../components/landing/WriteArticles";
import GenerateImages from "../components/landing/GenerateImages";
import MoreFeatures from "../components/landing/MoreFeatures";
import PublishContent from "../components/landing/PublishContent";
import PricingSection from "../components/landing/PricingSection";
import CTABanner from "../components/landing/CTABanner";
import Footer from "../components/landing/Footer";
import MobileFloatingCTA from "../components/landing/MobileFloatingCTA";

const HyperRankLanding = () => {
  const handleGetStarted = () => {
    window.location.href = '/signup';
  };

  return (
    <div className="min-h-screen font-sans bg-white relative">
      {/* Mobile Floating CTA */}
      <MobileFloatingCTA onGetStarted={handleGetStarted} />

      {/* Header/Navigation */}
      <Header onGetStarted={handleGetStarted} />

      <main>
        {/* Hero Section */}
        <HeroSection onGetStarted={handleGetStarted} />

        {/* Content Workflow Section */}
        <ContentWorkflow onGetStarted={handleGetStarted} />

        {/* Automated Content Pipeline Section */}
        <AutomatedContentPipeline onGetStarted={handleGetStarted} />

        {/* Problems & Solutions Section */}
        <ProblemsAndSolutions onGetStarted={handleGetStarted} />

        {/* SEO Analysis & Keyword Research Section */}
        <SEOAnalysisSection onGetStarted={handleGetStarted} />

        {/* Write Articles Section */}
        <WriteArticles onGetStarted={handleGetStarted} />

        {/* Generate Images Section */}
        <GenerateImages onGetStarted={handleGetStarted} />

        {/* Publish Content Section */}
        <PublishContent onGetStarted={handleGetStarted} />

        {/* More Features Section */}
        <MoreFeatures />

        {/* Pricing Section */}
        <PricingSection onGetStarted={handleGetStarted} />

        {/* Hero Banner */}
        <CTABanner onGetStarted={handleGetStarted} />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HyperRankLanding;
